import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import './SuccessDialog.css';

export default function SuccessDialog({ open, setShowSuccess, handleConnect }) {
  const handleClose = () => {
    handleConnect();
    setShowSuccess(false);
  };
  return (
    <div>
      <Dialog
        style={{ minWidth: 300 }}
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>Complete</DialogTitle>
        <DialogContent id='dialog-content'>
          <DialogContentText id='alert-dialog-description'>
            The sync has finished successfully.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
